import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useForm } from "react-hook-form";
import * as yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";
import axios from "axios";
import { update_quotation_api } from "../Config/API";
import { ToastContainer, toast } from "react-toastify";
import { calculateSinglePrice, determineGSTType } from "../Common/CommonFunction";


const schema = yup
  .object()
  .shape({
    
  })
  .required();
export const EditQuotation = () => {
  const location=useLocation(); 

  const {quotation_line_items:items, email,customer,address,gst_number,cgst_amount,sgst_amount,igst_amount,ugst_amount } = location.state; 

//    console.log("items",items); 
//    console.log("location.state",location.state)
  const [button_click, setButton_click] = useState(false);
  const [toolvalues, setToolvalues] = useState([]);

  
  const [gst_types, setGst_types] = useState([]);
  const navigate = useNavigate();

   useEffect(()=>{
    if(cgst_amount!==0 &sgst_amount!==0){
    setGst_types(["CGST", "SGST"])
    }else if(igst_amount !==0){
        setGst_types(["IGST"])
    }else{
        setGst_types(["UGST"])

    }
   let arr= items.map((ele)=>{
    
    let single_price=calculateSinglePrice(ele.amount, ele.discount,ele.quantity)
    let total_value_calculated=single_price*ele.quantity; 
    
        let obj={
          product_code:ele.product_code,
          product_id:ele.product_id,
          quantity: ele.quantity,
          price: single_price,
          total_value:total_value_calculated ,
          discount: ele.discount,
          discounted_value:ele.amount ,
        
        }
        return obj
      }); 
    //   console.log("arr",arr)
      setToolvalues(arr)
   },[])
  const handleChange = (index, field, value) => {
    console.log(index, field, value);
    const updatedData = [...toolvalues];
    updatedData[index][field] = Number(value);

    updatedData[index].total_value =
      updatedData[index].quantity * updatedData[index].price;
    updatedData[index].discounted_value =
      updatedData[index].total_value -
      (updatedData[index].total_value * updatedData[index].discount) / 100;

    console.log("updatedData", updatedData);
    setToolvalues(updatedData);
  };

  const {
    register,
    handleSubmit,
    formState,
    getValues,
    setError,
    control,
    clearErrors,
  } = useForm({
    resolver: yupResolver(schema),
    mode: "onChange",
  }); // initialise the hook


  const onSubmit = (data) => {
    setButton_click(true);
    console.log("location",location.state)
    console.log("data", data);
    console.log("toolsdata,", toolvalues);
    const today = new Date(location.state.quotation_date);
    console.log("today", today);

    const formattedDate = today.toISOString().split("T")[0];
    console.log(formattedDate);
    let line_items_payload=[]; 
    for(let i=0; i<items.length; i++){
      let quote_image_url = items[i].product_image;

      let dimension_arr = items[i].product_attributes.map((item) => {
      let obj = {
        uom_value: item.uom_value,
        attribute_value: item.attribute_value,
        tol_positive: item.tol_positive,
        tol_negative: item.tol_negative,
        parameters_code: item.parameters_code,
      };
      return obj;
    });
    console.log("dimension", dimension_arr);
      let obj={
        uuid:items[i].uuid,
        quantity:`${toolvalues[i].quantity}`,
        product_code:toolvalues[i].product_code,
        product_id:toolvalues[i].product_id,
        unit: "NOS",
        amount: toolvalues[i].discounted_value,
        gst_rate: 18,
        gst_amount: toolvalues[0].discounted_value * 0.18,
        discount: toolvalues[0].discount,
        product_attributes:dimension_arr,
        common_attributes: items[i].common_attributes,
          product_image:quote_image_url
      }; 

      line_items_payload.push(obj)

    }

    
    
    
    const payload = {
       uuid:location.state.uuid,
      quotation_date: formattedDate,
      customer: data.customer_name,
      gst_number: location.state.gst_number,
      address: data.address,
      status: "Pending",
      email: data.email,
      quote_products:line_items_payload,
      total_amount: `${toolvalues.reduce((ac,dc)=>{
              return ac+Number(dc.discounted_value)
      },0)}`,
    };

    if(gst_types.length==2){
      payload.cgst_amount=payload.total_amount*0.09;
      payload.sgst_amount=payload.total_amount*0.09;
    }else if(gst_types[0].toLowerCase()=="ugst"){
      payload.ugst_amount=payload.total_amount*0.18; 
    }else{
      payload.igst_amount=payload.total_amount*0.18; 

    }

    console.log("payload", payload);

    update_quotation_api(payload)
      .then((res) => {
        console.log("res", res);
        setButton_click(false);
        toast.success("Quotation updated successfully !", {
          autoClose: 2000,
        });
      
        setTimeout(() => {
          navigate("/quotation");
        }, [2200]);
      })
      .catch((err) => {
        console.log("err", err);
        setButton_click(false);
        toast.error("Something went wrong !", {
          autoClose: 2000,
        });
      });
  };
  const { errors } = formState;
  return (
    <>
      <div className="px-10 py-4 h-full overflow-y-auto pb-[10%] ">
        <ToastContainer />
        <h2 className="text-start mb-3 text-2xl font-semibold	">
          Quotation Update
        </h2>
        <hr className="w-90 h-1 mx-auto my-2 line-color border-0 rounded line-color" />

        <div className="h-full w-full">
          <div className="mb-4 pl-2">
            <h1 className="text-start mb-3 mt-2 text-lg 	">Customer Details</h1>
            <div className="mb-5 w-full">
             
                <div className="flex gap-4 mt-3">
                  <div className="flex-1">
                    <label className="block mb-2">Customer Name</label>
                    <input
                      type="text"
                      defaultValue={customer}
                      name="customer_name"
                      readOnly={true}
                      className="w-full p-2 border border-gray-300 rounded bg-gray-100"
                      {...register("customer_name")}
                    />
                  </div>
                  <div className="flex-1">
                    <label className="block mb-2">Customer Email</label>
                    <input
                      type="text"
                      defaultValue={email}
                      readOnly={true}
                      name="email"
                      placeholder="please enter customer email"
                      className="w-full p-2 border border-gray-300 rounded bg-gray-100"
                      {...register("email")}
                    />
                    <span className="text-danger" style={{ fontSize: "12px" }}>
                      {errors.email?.message}
                    </span>
                  </div>
                  <div className="flex-1">
                    <label className="block mb-2">GST Number</label>
                    <input
                      type="text"
                      defaultValue={gst_number}
                      readOnly={true}
                      className="w-full p-2 border border-gray-300 rounded bg-gray-100"
                    />
                  </div>
                </div>
             
                <div className=" mt-4">
                  <label className="block mb-2">Address</label>
                  <textarea
                    type="text"
                    name="address"
                    defaultValue={address}
                    readOnly={address}
                    className="resize w-1/2  p-2 border border-gray-300 rounded bg-gray-100"
                    {...register("address")}
                  />
                </div>
            </div>
          </div>
          <hr className="w-90 h-1 mx-auto my-2 line-color border-0 rounded line-color" />

          {items.map((ele) => {
            return (
              <div key={ele.uuid}>
                {/* <div className="justify-center">
                  <h1 className="text-start text-lg">Product Image</h1>
                  <div className="w-60 h-64 flex align-center">
                  <img
                    src={
                      ele.quotation_product_img ||
                      "https://via.placeholder.com/150"
                    }
                    alt={ele.product_code || "Product Image"}
                  />
                  </div>
                 
                </div>
                <hr className="w-90 h-1 mx-auto my-1 line-color border-0 rounded line-color" /> */}

                <div className="mb-4 pl-2">
                  <h1 className="text-start mb-3 mt-2 text-lg">
                    Tool Dimensions
                  </h1>

                  <table className="min-w-full mt-2 table-auto border-collapse border border-gray-300">
                    <thead className="bg-gray-200 font-bold">
                      <tr>
                        <th className="border border-gray-300 px-4 py-2 text-start">
                          Dimensional Parameters
                        </th>
                        <th className="border border-gray-300 px-4 py-2">
                          Value
                        </th>
                        <th className="border border-gray-300 px-4 py-2">
                          UOM
                        </th>
                        <th className="border border-gray-300 px-4 py-2">
                          + TOL
                        </th>
                        <th className="border border-gray-300 px-4 py-2">
                          - TOL
                        </th>
                      </tr>
                    </thead>
                    <tbody className="text-gray-700">
                      {ele.product_attributes.map((item, i) => (
                        <tr key={item.uuid}>
                          <td className="border border-gray-300 px-4 py-2 ">
                            {item.parameters_code}
                          </td>
                          <td className="border border-gray-300 px-4 py-2 text-center">
                            {item.attribute_value}
                          </td>
                          <td className="border border-gray-300 px-4 py-2 text-center">
                            {item.uom_value}
                          </td>
                          <td className="border border-gray-300 px-4 py-2 text-center">
                            {item.tol_positive}
                          </td>
                          <td className="border border-gray-300 px-4 py-2 text-center">
                            {item.tol_negative}
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>

                <hr className="w-90 h-1 mx-auto my-1 line-color border-0 rounded line-color" />

                <div className="mb-4 pl-2">
                  <h1 className="text-start mb-3 mt-2 text-lg">
                    Common Attributes
                  </h1>

                  <div className="flex flex-wrap gap-4">
                    {ele.common_attributes.map((item,j) => {
                      return (
                        <div key={item+j} className="flex-32">
                          <label className="block mb-2">{item.name}</label>
                          <input
                            type="text"
                            value={item.value}
                            // value={`${location.state.common_attributes.item.value}`}
                            disabled
                            className="w-full p-2 border border-gray-300 rounded"
                          />
                        </div>
                      );
                    })}
                  </div>
                </div>
              </div>
            );
          })}

          <hr className="w-90 h-1 mx-auto my-1 line-color border-0 rounded line-color" />
          <div className="mb-4 pl-2">
            <h1 className="text-start mb-3 mt-2 text-lg">
              Pricing and Terms & Condition
            </h1>
            <table className="min-w-full mt-2 table-auto border-collapse border border-gray-300">
              <thead className="bg-gray-200 font-bold">
                <tr>
                <th className="border border-gray-300 px-4 py-2 text-start">
                    Product Code
                  </th>
                  
                  <th className="border border-gray-300 px-4 py-2 text-start">
                    Quantity
                  </th>
                  <th className="border border-gray-300 px-4 py-2">
                    Value/Unit
                  </th>
                  <th className="border border-gray-300 px-4 py-2">
                    Total Value
                  </th>
                  <th className="border border-gray-300 px-4 py-2">
                    Discout %
                  </th>
                  <th className="border border-gray-300 px-4 py-2">
                    Discounted Value
                  </th>
                </tr>
              </thead>
              <tbody className="text-gray-700">
                {toolvalues.length > 0 &&
                  toolvalues.map(
                    (
                      {
                        product_code,
                        quantity,
                        price,
                        discount,
                        discounted_value,
                        total_value,
                      },
                      index
                    ) => (
                      <tr key={product_code + index}>
                        <td className="border border-gray-300 px-4 py-2 ">
                          <input
                            type="text"
                            min="1"
                            className="w-40 p-2 border border-gray-300 rounded"
                            value={product_code}
                            readOnly                           
                          />
                        </td>
                        <td className="border border-gray-300 px-4 py-2 ">
                          <input
                            type="number"
                            min="1"
                            className="w-20 p-2 border border-gray-300 rounded"
                            defaultValue={quantity}
                            onChange={(e) =>
                              handleChange(index, "quantity", e.target.value)
                            }
                          />
                        </td>
                        <td className="border border-gray-300 px-4 py-2 text-center">
                          <input
                            type="number"
                            min={"1"}
                            defaultValue={price}
                            onChange={(e) =>
                              handleChange(index, "price", e.target.value)
                            }
                            className="w-20 p-2 border border-gray-300 rounded"
                          />
                        </td>
                        <td className="border border-gray-300 px-4 py-2 text-center">
                          <input
                            type="number"
                            value={total_value}
                            disabled
                            className="w-20 p-2 border border-gray-300 rounded"
                          />
                        </td>
                        <td className="border border-gray-300 px-4 py-2 text-center">
                          <input
                            type="number"
                            min="0"
                            defaultValue={discount}
                            onChange={(e) =>
                              handleChange(index, "discount", e.target.value)
                            }
                            className="w-20 p-2 border border-gray-300 rounded"
                          />
                        </td>
                        <td className="border border-gray-300 px-4 py-2 text-center">
                          <input
                            type="number"
                            value={discounted_value}
                            disabled
                            className="w-20 p-2 border border-gray-300 rounded"
                          />
                        </td>

                      </tr>
                    )
                  )}
              </tbody>
            </table>
          </div>
          <hr className="w-90 h-1 mx-auto my-1 line-color border-0 rounded line-color" />
          <div className="mb-4 pl-2">
            <h1 className="text-start mb-3 mt-2 text-lg">GST Details</h1>
            <table className="min-w-full mt-2 table-auto border-collapse border border-gray-300">
              <thead className="bg-gray-200 font-bold">
                <tr>
                  <th className="border border-gray-300 px-4 py-2 text-start">
                    HSN
                  </th>
                  <th className="border border-gray-300 px-4 py-2">GST</th>
                  {/* <th className="border border-gray-300 px-4 py-2">CGST</th>
                <th className="border border-gray-300 px-4 py-2">SGST</th> */}
                  {gst_types.map((item,k) => {
                    return (
                      <th key={item+k} className="border border-gray-300 px-4 py-2">
                        {item}
                      </th> 
                    );
                  })}
                </tr>
              </thead>
              <tbody className="text-gray-700">
                {[1].map((item, index) => (
                  <tr key={index + item}>
                    <td className="border border-gray-300 px-4 py-2 ">
                      {" 82078000"}
                    </td>
                    <td className="border border-gray-300 px-4 py-2 text-center">
                      {"18%"}
                    </td>
                    {/* <td className="border border-gray-300 px-4 py-2 text-center">
                    {"9%"}
                  </td>
                  <td className="border border-gray-300 px-4 py-2 text-center">
                    {"9%"}
                  </td> */}
                    {gst_types.map((item) => {
                      return (
                        <>
                          {item == "UGST" && (
                            <td className="border border-gray-300 px-4 py-2 text-center">
                              {"18%"}
                            </td>
                          )}
                          {item == "IGST" && (
                            <td className="border border-gray-300 px-4 py-2 text-center">
                              {"18%"}
                            </td>
                          )}
                          {item == "CGST" && (
                            <td className="border border-gray-300 px-4 py-2 text-center">
                              {"9%"}
                            </td>
                          )}
                          {item == "SGST" && (
                            <td className="border border-gray-300 px-4 py-2 text-center">
                              {"9%"}
                            </td>
                          )}
                        </>
                      );
                    })}
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
          <hr className="w-90 h-1 mx-auto my-1 line-color border-0 rounded line-color" />
          <div className="mt-4 ">
            <button
              className={
                button_click == false
                  ? `w-40 main-color  p-2 rounded-lg text-white  cursor-pointer`
                  : `w-40 secondary-color p-2 rounded-lg text-white  cursor-pointer`
              }
              disabled={button_click}
              onClick={handleSubmit(onSubmit)}
            >
              {button_click ? (
                  <div className="flex items-center gap-2">
                    <svg
                      className="animate-spin h-5 w-5 text-white"
                      xmlns="http://www.w3.org/2000/svg"
                      fill="none"
                      viewBox="0 0 24 24"
                    >
                      <circle
                        className="opacity-25"
                        cx="12"
                        cy="12"
                        r="10"
                        stroke="currentColor"
                        strokeWidth="4"
                      ></circle>
                      <path
                        className="opacity-75"
                        fill="currentColor"
                        d="M4 12a8 8 0 018-8v8H4z"
                      ></path>
                    </svg>
                    <span>Updating...</span>
                  </div>
                ) : (
                  " Update Quotation"
                )}
             
            </button>
          </div>
        </div>
      </div>
    </>
  );
};
